import { useEffect } from "react";
import { useAuthdAPI } from "../api";
import { WootingUser } from "../constants/types";
import { useErrorToast } from "../showToast";

export default function useWootingUser() {
  const { data, error, mutate: mutateUser } = useAuthdAPI<WootingUser>("user");
  const showErrorToast = useErrorToast();

  useEffect(() => {
    if (error) showErrorToast(error);
  }, [error, showErrorToast]);

  return [data, mutateUser] as const;
}
